
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.375 10L8.583 8.79a.765.765 0 00.24-.583.875.875 0 00-.24-.583.848.848 0 00-.593-.26.78.78 0 00-.594.239L5.583 9.416a.8.8 0 00-.25.584.8.8 0 00.25.583l1.813 1.813a.777.777 0 00.594.24.844.844 0 00.593-.261.88.88 0 00.24-.584.76.76 0 00-.24-.583L7.375 10zm5.25 0l-1.208 1.208a.765.765 0 00-.24.583.875.875 0 00.24.584.849.849 0 00.594.26.776.776 0 00.593-.24l1.813-1.812a.8.8 0 00.25-.583.8.8 0 00-.25-.584l-1.813-1.812a.777.777 0 00-.593-.24.849.849 0 00-.594.26.877.877 0 00-.24.584.766.766 0 00.24.583L12.625 10zm-8.458 7.5c-.459 0-.85-.163-1.177-.49a1.608 1.608 0 01-.49-1.177V4.166c0-.458.163-.85.49-1.176.327-.326.719-.49 1.177-.49h3.5c.18-.5.482-.903.906-1.209.424-.305.9-.458 1.427-.458s1.003.153 1.428.458c.424.306.726.709.905 1.209h3.5c.459 0 .851.163 1.178.49.326.326.49.719.489 1.176v11.667c0 .458-.163.85-.49 1.178-.325.326-.718.49-1.177.489H4.167zM10 3.54a.608.608 0 00.625-.625.605.605 0 00-.625-.625.605.605 0 00-.625.625.605.605 0 00.625.625z","fill":"#348EF6"}})])
          )
        }
      }
    